import { useState } from "react";
import { Layout } from "antd";
import type { User as AuthUser } from "firebase/auth";
import type { CreateMailOrderResponse } from "@gull/shared";
import { useProfile } from "../../lib/useProfile";
import BestillPoseWizard from "../bestill-pose/BestillPoseWizard";
import HelpCard from "../bestill-pose/HelpCard";

const { Content } = Layout;

/** The frame has nowhere to navigate to, so a finished order is confirmed where the wizard stood. */
function OrderConfirmation({ order }: { order: CreateMailOrderResponse }) {
  return (
    <>
      <p className="sendin-subtitle">Kvitteringskode {order.receiptCode}</p>
      <HelpCard />
    </>
  );
}

export default function EmbedBestillPose({ user }: { user: AuthUser }) {
  const profile = useProfile(user.uid);
  const [confirmed, setConfirmed] = useState<CreateMailOrderResponse | null>(null);

  return (
    <Content className="sendin-page">
      {confirmed ? (
        <OrderConfirmation order={confirmed} />
      ) : (
        <BestillPoseWizard user={user} profile={profile} onSubmitted={setConfirmed} />
      )}
    </Content>
  );
}
